import { useEffect, useState } from "react";
import { getClient } from "../api/clients";

/**
 * The client's name for a page header, read once per client; "" until it is
 * read or when it cannot be (the page's own content says what went wrong).
 */
export function useClientName(clientId: number): string {
  const [name, setName] = useState("");

  useEffect(() => {
    if (isNaN(clientId)) return;
    let cancelled = false;
    getClient(clientId)
      .then((client) => {
        if (!cancelled) setName(client.business_name);
      })
      .catch(() => {
        if (!cancelled) setName("");
      });
    return () => {
      cancelled = true;
    };
  }, [clientId]);

  return name;
}
